module.exports = __webpack_public_path__ + "img/icon_connect_pink.b0259745.svg";